export enum ElementDescriptionTarget {
  Node = 'Node',
  Zone = 'Zone',
}
